import { Button, Card, CardContent, CircularProgress, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import React from 'react';
import { ValidatorForm } from 'react-form-validator-core';

import InputValidator from '@/components/input-validator';

const styles = (theme: Theme) =>
  createStyles({
    progress: {
      marginTop: theme.spacing(14),
    },
    loginCard: {
      [theme.breakpoints.down('xs')]: {
        height: '100%',
      },
    },
    cardPadding: {
      height: '100%',
      paddingRight: '2em',
      paddingLeft: '2em',
      paddingTop: '2em',
      [theme.breakpoints.up('sm')]: {
        width: '500px !important', // 580
        height: '300px !important', // 340
        paddingRight: '4em !important',
        paddingLeft: '4em !important',
      },
    },
    cardPaddingLoading: {
      height: '100%',
      paddingRight: '2em',
      paddingLeft: '2em',
      paddingTop: '2em',
      [theme.breakpoints.up('sm')]: {
        width: '500px !important', // 580
        height: '370px !important', // 340
        paddingRight: '4em !important',
        paddingLeft: '4em !important',
      },
    },
    textFields: {
      width: '100%',
    },
    heading: {
      textAlign: 'center',
    },
    containerClass: {
      width: '100%',
      display: 'block',
      textAlign: 'center',
      height: '100%',
    },
    checkmark: {
      width: '74px',
      display: 'block',
      margin: '0 auto',
      marginTop: theme.spacing(14),
    },
    checkmarkCircle: {
      strokeDasharray: 1000,
      strokeDashoffset: 0,
      animation: 'dash 0.9s ease-in-out',
    },
    checkmarkCheck: {
      strokeDasharray: 1000,
      strokeDashoffset: 1000,
      animation: 'dash-check 0.9s 0.35s ease-in-out forwards',
    },
    '@keyframes dash': {
      '0%': {
        strokeDashoffset: 1000,
      },
      '100%': {
        strokeDashoffset: 0,
      },
    },
    '@keyframes dash-check': {
      '0%': {
        strokeDashoffset: 1000,
      },
      '100%': {
        strokeDashoffset: 100,
      },
    },
  });

interface IMyProps {
  username: string;
  onSubmit: any;
  onChangeUser: any;
  onChangePass: any;
  isLoading: boolean;
  isSuccessful: boolean;
  onCancel: any;
}

class ForgotPassword extends React.Component<IMyProps & WithStyles<typeof styles>, {}> {
  onSubmit(e: any) {
    const payload = {
      username: this.props.username ? this.props.username.toLowerCase() : this.props.username,
      resetPassword: true,
    };

    this.props.onChangePass('');

    this.props.onSubmit(e, payload);
  }

  render() {
    const { classes, onCancel } = this.props;

    let card = (
      <CardContent className={classes.cardPadding}>
        <ValidatorForm ref="form" method="post" onSubmit={(event: any) => this.onSubmit(event)}>
          <Typography className={classes.heading} variant="h5">
            Reset password
          </Typography>
          <br />
          <br />
          <InputValidator
            className={classes.textFields}
            containerClass={classes.containerClass}
            name="username"
            label="Email"
            validators={['required', 'isEmail']}
            errorMessages={['this field is required', 'must be a valid email']}
            value={this.props.username}
            onChange={(e) => {
              this.props.onChangeUser(e.target.value);
            }}
          />
          <br />
          <br />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button variant="contained" color="primary" type="submit">
              Reset password
            </Button>
            <Button variant="text" color="primary" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </ValidatorForm>
      </CardContent>
    );

    if (this.props.isSuccessful) {
      card = (
        <CardContent className={classes.cardPaddingLoading}>
          <div className={classes.containerClass}>
            <Typography className={classes.heading} variant="h5">
              Successfully signed in!
            </Typography>
            <svg
              className={classes.checkmark}
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2">
              <circle
                className={classes.checkmarkCircle}
                fill="none"
                stroke="#73AF55"
                strokeWidth="9"
                strokeMiterlimit="10"
                cx="65.1"
                cy="65.1"
                r="60.1"
              />
              <polyline
                className={classes.checkmarkCheck}
                fill="none"
                stroke="#73AF55"
                strokeWidth="9"
                strokeLinecap="round"
                strokeMiterlimit="10"
                points="100.2,40.2 51.5,88.8 29.8,67.5 "
              />
            </svg>
          </div>
        </CardContent>
      );
    } else if (this.props.isLoading) {
      card = (
        <CardContent className={classes.cardPaddingLoading}>
          <div className={classes.containerClass}>
            <Typography className={classes.heading} variant="h5">
              Resetting your password...
            </Typography>
            <Typography className={classes.heading} variant="subtitle1">
              Please check your email for your confirmation code
            </Typography>
            <CircularProgress className={classes.progress} size={80} color="secondary" />
          </div>
        </CardContent>
      );
    }

    return <Card className={classes.loginCard}>{card}</Card>;
  }
}

export default withStyles(styles)(ForgotPassword);
